import { useEffect, useState } from "react"
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import Form from 'react-bootstrap/Form'
import { showDangerToast } from '../../constants/toaster'
import { useDispatch, useSelector } from "react-redux"
import { updateLoading } from "../../../redux/features/common/commonSlice"
import urls from "../../constants/apiurl"
import ApiCaller from "../../constants/ApiCaller"
import { Dropdown } from "react-bootstrap"
import { Switch } from "@mui/material"
import Drawer from '@mui/material/Drawer';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
const label = { inputProps: { 'aria-label': 'Size switch demo' } }

export const AddTaxTemplate = (props) => {
    const dispatch = useDispatch()
    const userData = useSelector((state) => state?.userData);
    const [countryDropdownText, setCountryDropdownText] = useState({
        id: "",
        lable: "Select Country"
    });
    const [errors, setErrors] = useState({});
    const [parentTaxTemplateList, setParentTaxTemplateList] = useState([]);
    const [modalVisible, setModalVisible] = useState(true);

    const validate = () => {
        console.log("taxTemplateFormData", props?.taxTemplateFormData);
        const newErrors = {};
        if (!props?.taxTemplateFormData?.name?.trim()) {
            newErrors.name = 'Name is required*';
        }
        if (!props?.taxTemplateFormData?.taxRate) {
            newErrors.taxRate = 'Tax Rate is required*';
        } else if (isNaN(props?.taxTemplateFormData?.taxRate)) {
            newErrors.taxRate = 'Tax Rate must be a number';
        }
        if (!props?.taxTemplateFormData?.countryId) {
            newErrors.countryId = 'Country is required*';
        }
        if (props?.taxTemplateFormData?.percentageOnTaxType && !props?.taxTemplateFormData?.percentageOnTypeId) {
            newErrors.percentageOnTypeId = 'Parent Tax Template is required*';
        }
        return newErrors;
    };

    const handleSubmit = () => {
        const validationErrors = validate();
        setErrors(validationErrors);
        if (Object.keys(validationErrors).length > 0) {
            showDangerToast('Please fill all required fields correctly');
            return;
        }
        props?.onSubmit()
    };

    useEffect(() => {
        if (props?.taxTemplateFormData?.countryId) {
            for (const data of props?.countryCodeList) {
                if (data?.id === props?.taxTemplateFormData?.countryId) {
                    setCountryDropdownText({
                        id: data?.id,
                        lable: data?.name
                    })
                }
            }
        }
    }, [props?.taxTemplateFormData?.countryId, props?.countryCodeList])

    // Fetch parent tax templates when country is selected
    useEffect(() => {
        console.log("taxTemplateFormData", props.taxTemplateFormData)
        if (props.taxTemplateFormData.countryId) {
            console.log("Fetching parent tax templates for country:", props.taxTemplateFormData.countryId);
            const fetchParentTaxTemplates = async () => {
                try {
                    dispatch(updateLoading(true));
                    let res = await ApiCaller.get(
                        { countryId: props.taxTemplateFormData.countryId }, 
                        urls.GET_PARENT_TAX_TEMPLATES, 
                        userData?.access_token
                    );
                    const response = await res.response.json();
                    if (response.status == 200 || response.status == '200') {
                        setParentTaxTemplateList(response.data || []);
                    } else {
                        console.error('Error response:', response);
                        showDangerToast(response.message || 'Failed to fetch parent tax templates');
                        setParentTaxTemplateList([]);
                    }
                    dispatch(updateLoading(false));
                } catch (error) {
                    dispatch(updateLoading(false));
                    console.error('Error fetching parent tax templates:', error);
                    showDangerToast('Failed to fetch parent tax templates');
                    setParentTaxTemplateList([]);
                }
            };
            fetchParentTaxTemplates();
        } else {
            setParentTaxTemplateList([]);
        }
    }, [props.taxTemplateFormData.countryId]);

    const handleInputChange = (e, inputType) => {
        const value = e.target.value;
        props.setTaxTemplateFormData({
            ...props?.taxTemplateFormData,
            [inputType]: value
        })
        setErrors({ ...errors, [inputType]: undefined });
    };

    const handleToggleChange = (field, value) => {
        const updatedFormData = { ...props.taxTemplateFormData, [field]: value };

        // Reset percentageOnTypeId when percentageOnTaxType is turned off
        if (field === 'percentageOnTaxType' && !value) {
            updatedFormData.percentageOnTypeId = '';
        }

        // Reset percentageOnTypeId when country changes
        if (field === 'countryId') {
            updatedFormData.percentageOnTypeId = '';
        }

        props.setTaxTemplateFormData(updatedFormData);
        setErrors({ ...errors, [field]: undefined, percentageOnTypeId: undefined });
    };

    return (
        <>
            {modalVisible && (
                <Modal
                    {...props}
                    size='lg'
                    aria-labelledby='contained-modal-title-vcenter'
                    centered
                >
                    <Modal.Header>
                        <Modal.Title id='contained-modal-title-vcenter'>
                            {props?.taxTemplateFormData?.id ? 'Update Tax Template' : 'Add Tax Template'}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className='container-fluid'>
                            {/* Tax Info Section */}
                            <div className='row mb-3'>
                                <div className='col-md-6 mb-3'>
                                    <Form.Group controlId='taxNameInput'>
                                        <Form.Label className='fw-bold'>Tax Name<span className='text-danger'>*</span></Form.Label>
                                        <Form.Control
                                            type='text'
                                            placeholder='Enter Tax Name'
                                            value={props.taxTemplateFormData.name || ''}
                                            onChange={e => handleInputChange(e, 'name')}
                                            isInvalid={!!errors.name}
                                        />
                                        {errors.name && (
                                            <div className='text-danger small'>{errors.name}</div>
                                        )}
                                    </Form.Group>
                                </div>
                                <div className='col-md-6 mb-3'>
                                    <Form.Group controlId='taxRateInput'>
                                        <Form.Label className='fw-bold'>Tax Rate<span className='text-danger'>*</span></Form.Label>
                                        <Form.Control
                                            type='number'
                                            step='0.01'
                                            placeholder='Enter Tax Rate'
                                            value={props.taxTemplateFormData.taxRate || ''}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                if (value === '' || /^\d*\.?\d*$/.test(value)) {
                                                    props.setTaxTemplateFormData({
                                                        ...props?.taxTemplateFormData,
                                                        'taxRate': value
                                                    })
                                                    setErrors({ ...errors, taxRate: undefined });
                                                }
                                            }}
                                            isInvalid={!!errors.taxRate}
                                        />
                                        {errors.taxRate && (
                                            <div className='text-danger small'>{errors.taxRate}</div>
                                        )}
                                    </Form.Group>
                                </div>
                            </div>

                            {/* Country Section */}
                            <div className='row mb-3'>
                                <div className='col-md-6 mb-3'>
                                    <Form.Group controlId='countryIdInput'>
                                        <TextField
                                            select
                                            fullWidth
                                            label="Country"
                                            value={props.taxTemplateFormData.countryId || ''}
                                            onChange={e => {
                                                setCountryDropdownText({
                                                    id: e.target.value,
                                                    lable: props.countryCodeList.find(c => c.id === e.target.value)?.name || 'Select Country'
                                                });
                                                props.setTaxTemplateFormData({
                                                    ...props.taxTemplateFormData,
                                                    countryId: e.target.value,
                                                    percentageOnTypeId: '' // Reset parent tax template selection
                                                });
                                                setErrors({ ...errors, countryId: undefined, percentageOnTypeId: undefined });
                                            }}
                                            required
                                            size="small"
                                            error={!!errors.countryId}
                                            helperText={errors.countryId || ''}
                                        >
                                            <MenuItem value=''>Select Country</MenuItem>
                                            {props.countryCodeList.map(item => (
                                                <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>
                                            ))}
                                        </TextField>
                                    </Form.Group>
                                </div>
                            </div>

                            {/* Tax Type Toggles */}
                            <div className='row mb-3'>
                                <div className='col-md-6 mb-3'>
                                    <Form.Group controlId='fixedToggle'>
                                        <Form.Label className='fw-bold'>Fixed Amount</Form.Label>
                                        <div className='d-flex align-items-center'>
                                            <Switch
                                                {...label}
                                                checked={props?.taxTemplateFormData?.fixed || false}
                                                onChange={e => handleToggleChange('fixed', e.target.checked)}
                                                size='small'
                                            />
                                            <span className='ms-2'>{props?.taxTemplateFormData?.fixed ? 'Yes' : 'No'}</span>
                                        </div>
                                        <Form.Text className='text-muted'>
                                            {props?.taxTemplateFormData?.fixed ? 'Tax will be applied as a fixed amount' : 'Tax will be applied as a percentage'}
                                        </Form.Text>
                                    </Form.Group>
                                </div>
                                <div className='col-md-6 mb-3'>
                                    <Form.Group controlId='percentageOnTaxTypeToggle'>
                                        <Form.Label className='fw-bold'>Percentage on Tax Type</Form.Label>
                                        <div className='d-flex align-items-center'>
                                            <Switch
                                                {...label}
                                                checked={props?.taxTemplateFormData?.percentageOnTaxType || false}
                                                onChange={e => handleToggleChange('percentageOnTaxType', e.target.checked)}
                                                size='small'
                                            />
                                            <span className='ms-2'>{props?.taxTemplateFormData?.percentageOnTaxType ? 'Yes' : 'No'}</span>
                                        </div>
                                        <Form.Text className='text-muted'>
                                            Calculate tax as percentage of parent tax template
                                        </Form.Text>
                                    </Form.Group>
                                </div>
                            </div>

                            {/* Parent Tax Template Selection */}
                            {props.taxTemplateFormData.percentageOnTaxType && (
                                <div className='row mb-3'>
                                    <div className='col-md-6 mb-3'>
                                        <Form.Group controlId='parentTaxTemplateInput'>
                                            <TextField
                                                select
                                                fullWidth
                                                label="Parent Tax Template"
                                                value={props.taxTemplateFormData.percentageOnTypeId || ''}
                                                onChange={e => {
                                                    props.setTaxTemplateFormData({
                                                        ...props.taxTemplateFormData,
                                                        percentageOnTypeId: e.target.value
                                                    });
                                                    setErrors({ ...errors, percentageOnTypeId: undefined });
                                                }}
                                                required
                                                size="small"
                                                error={!!errors.percentageOnTypeId}
                                                helperText={errors.percentageOnTypeId || ''}
                                            >
                                                <MenuItem value=''>Select Parent Tax Template</MenuItem>
                                                {parentTaxTemplateList.map(item => (
                                                    <MenuItem key={item.key} value={item.key}>{item.value}</MenuItem>
                                                ))}
                                            </TextField>
                                        </Form.Group>
                                    </div>
                                </div>
                            )}
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant='outline-secondary' onClick={() => {
                            setCountryDropdownText({ id: '', lable: 'Select Country' });
                            props.onHide();
                            setErrors({});
                        }}>Cancel</Button>
                        <Button variant='primary' onClick={handleSubmit}>Submit</Button>
                    </Modal.Footer>
                </Modal>
            )}
        </>
    );
}